
document.addEventListener('DOMContentLoaded', function () {
    const multiVariantSelector = document.querySelector('[id^="multi-variant-selector-"]');
    if (!multiVariantSelector) return;

    const checkboxes = multiVariantSelector.querySelectorAll('.variant-checkbox');
    const quantityInputs = multiVariantSelector.querySelectorAll('.quantity-input');
    const quantityBtns = multiVariantSelector.querySelectorAll('.quantity-btn');
    const selectedVariantsList = multiVariantSelector.querySelector('.selected-variants-list');
    const selectedVariantsSummary = multiVariantSelector.querySelector('.selected-variants-summary');
    const totalPrice = multiVariantSelector.querySelector('.total-price');
    const addToCartBtn = multiVariantSelector.querySelector('.multi-add-to-cart-btn');
    const multiVariantForm = multiVariantSelector.querySelector('.multi-variant-form');

    let selectedVariants = [];

    // Handle checkbox changes
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            const variantId = this.dataset.variantId;
            const variantTitle = this.dataset.variantTitle;
            const variantPrice = parseFloat(this.dataset.variantPrice);
            const variantItem = this.closest('.variant-item');
            const quantityInput = variantItem.querySelector('.quantity-input');

            if (this.checked) {
                // Add to selected variants
                selectedVariants.push({
                    id: variantId,
                    title: variantTitle,
                    price: variantPrice,
                    quantity: parseInt(quantityInput.value)
                });
            } else {
                // Remove from selected variants
                selectedVariants = selectedVariants.filter(v => v.id !== variantId);
            }

            updateSummary();
        });
    });

    // Handle quantity changes
    quantityInputs.forEach(input => {
        input.addEventListener('change', function () {
            const variantId = this.dataset.variantId;
            const variant = selectedVariants.find(v => v.id === variantId);
            if (variant) {
                variant.quantity = parseInt(this.value);
                updateSummary();
            }
        });
    });

    // Handle quantity buttons
    quantityBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            const action = this.dataset.action;
            const variantItem = this.closest('.variant-item');
            const quantityInput = variantItem.querySelector('.quantity-input');
            const currentValue = parseInt(quantityInput.value);
            const maxValue = parseInt(quantityInput.max);

            if (action === 'increase' && currentValue < maxValue) {
                quantityInput.value = currentValue + 1;
            } else if (action === 'decrease' && currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }

            // Trigger change event
            quantityInput.dispatchEvent(new Event('change'));
        });
    });

    // Update summary display
    function updateSummary() {
        if (selectedVariants.length > 0) {
            selectedVariantsSummary.style.display = 'block';
            addToCartBtn.disabled = false;

            // Update selected variants list
            selectedVariantsList.innerHTML = '';
            let total = 0;

            selectedVariants.forEach(variant => {
                const itemTotal = variant.price * variant.quantity;
                total += itemTotal;

                const variantItem = document.createElement('div');
                variantItem.className = 'selected-variant-item';
                variantItem.innerHTML = `
              <div class="selected-variant-info">
                <div class="selected-variant-title">${variant.title}</div>
                <div class="selected-variant-price">${(variant.price / 100).toFixed(2)} each</div>
              </div>
              <div class="selected-variant-quantity">Qty: ${variant.quantity}</div>
            `;
                selectedVariantsList.appendChild(variantItem);
            });

            totalPrice.textContent = `$${(total / 100).toFixed(2)}`;
        } else {
            selectedVariantsSummary.style.display = 'none';
            addToCartBtn.disabled = true;
        }
    }

    // Handle add to cart
    addToCartBtn.addEventListener('click', function () {
        if (selectedVariants.length === 0) return;

        // Create form data for each variant
        const formData = new FormData();

        selectedVariants.forEach(variant => {
            formData.append('items[][id]', variant.id);
            formData.append('items[][quantity]', variant.quantity);
        });

        // Add to cart using Shopify's AJAX API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: selectedVariants.map(variant => ({
                    id: parseInt(variant.id),
                    quantity: variant.quantity
                }))
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    // Error occurred
                    alert('Error adding items to cart: ' + data.description);
                } else {
                    // Success - update cart count and show success message
                    updateCartCount();
                    showSuccessMessage();

                    // Reset form
                    checkboxes.forEach(cb => cb.checked = false);
                    quantityInputs.forEach(input => input.value = 1);
                    selectedVariants = [];
                    updateSummary();
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Error adding items to cart. Please try again.');
            });
    });

    // Update cart count (you may need to adjust this based on your theme)
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartCountElements = document.querySelectorAll('[data-cart-count]');
                cartCountElements.forEach(element => {
                    element.textContent = cart.item_count;
                });
            });
    }

    // Show success message
    function showSuccessMessage() {
        const message = document.createElement('div');
        message.className = 'success-message';
        message.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #28a745;
          color: white;
          padding: 15px 20px;
          border-radius: 6px;
          z-index: 1000;
          animation: slideIn 0.3s ease;
        `;
        message.textContent = 'Items added to cart successfully!';

        document.body.appendChild(message);

        setTimeout(() => {
            message.remove();
        }, 3000);
    }

    // Add CSS for success message animation
    if (!document.querySelector('#multi-variant-styles')) {
        const style = document.createElement('style');
        style.id = 'multi-variant-styles';
        style.textContent = `
          @keyframes slideIn {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
        `;
        document.head.appendChild(style);
    }
});
